module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/corporate-schools-d61cd754b8a6ffb9218c9baa93978255.jpg";